import React, { useState } from 'react';
import { Plan } from './types';
import './AddPlanModal.css';

interface EditPlanModalProps {
    plan: Plan;
    onSave: (plan: Plan) => void;
    onClose: () => void;
}

const EditPlanModal: React.FC<EditPlanModalProps> = ({ plan, onSave, onClose }) => {
    const [editedPlan, setEditedPlan] = useState<Plan>({...plan});

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSave(editedPlan);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Edit plan</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Plan ID:</label>
                        <input
                            type="text"
                            value={editedPlan.planId}
                            disabled
                            className="disabled-input"
                        />
                    </div>
                    <div className="form-group">
                        <label>Stripe ID:</label>
                        <input
                            type="text"
                            value={editedPlan.stripeId}
                            disabled
                            className="disabled-input"
                        />
                    </div>
                    <div className="form-group">
                        <label>Available credits:</label>
                        <input
                            type="number"
                            value={editedPlan.limits.creditsAvailable}
                            onChange={(e) => setEditedPlan({
                                ...editedPlan, 
                                limits: {
                                    ...editedPlan.limits,
                                    creditsAvailable: Number(e.target.value)
                                }
                            })}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>HD Generation:</label>
                        <input
                            type="checkbox"
                            checked={editedPlan.limits.HDGenerationAvailable}
                            onChange={(e) => setEditedPlan({
                                ...editedPlan,
                                limits: {
                                    ...editedPlan.limits,
                                    HDGenerationAvailable: e.target.checked
                                }
                            })}
                        />
                    </div>
                    <div className="form-group">
                        <label>Available chat sessions:</label>
                        <input
                            type="number"
                            value={editedPlan.limits.chatSessionsAvailable}
                            onChange={(e) => setEditedPlan({
                                ...editedPlan, 
                                limits: {
                                    ...editedPlan.limits,
                                    chatSessionsAvailable: Number(e.target.value)
                                }
                            })}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Price:</label>
                        <input
                            type="number"
                            value={editedPlan.price}
                            disabled
                            className="disabled-input"
                        />
                    </div>
                    <div className="form-group">
                        <label>Period:</label>
                        <input
                            type="text"
                            value={editedPlan.period}
                            disabled
                            className="disabled-input"
                        />
                    </div>
                    <div className="modal-buttons">
                        <button type="button" onClick={onClose} className="cancel-button">Cancel</button>
                        <button type="submit" className="save-button">Save changes</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditPlanModal; 